"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createNetworkFetcher;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _fetch2 = _interopRequireDefault(require("@adeira/fetch"));

var _helpers = require("./helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function createNetworkFetcher(graphQLServerURL, additionalHeaders, refetchConfig) {
  return /*#__PURE__*/function () {
    var _fetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(request, variables, uploadables) {
      var _yield$additionalHead;

      var body, resolvedAdditionalHeaders, headers, response;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              body = (0, _helpers.getRequestBody)(request, variables, uploadables); // sometimes it's necessary to get headers asynchronously (while refreshing authorization
              // token for example) - for this reason we accept object or promise here and we always
              // resolve it as a promise (see tests)

              _context.next = 3;
              return additionalHeaders;

            case 3:
              _context.t1 = _yield$additionalHead = _context.sent;
              _context.t0 = _context.t1 !== null;

              if (!_context.t0) {
                _context.next = 7;
                break;
              }

              _context.t0 = _yield$additionalHead !== void 0;

            case 7:
              if (!_context.t0) {
                _context.next = 11;
                break;
              }

              _context.t2 = _yield$additionalHead;
              _context.next = 12;
              break;

            case 11:
              _context.t2 = {};

            case 12:
              resolvedAdditionalHeaders = _context.t2;
              headers = _objectSpread(_objectSpread({}, (0, _helpers.getHeaders)(uploadables)), resolvedAdditionalHeaders);
              _context.next = 16;
              return (0, _fetch2.default)(graphQLServerURL, _objectSpread({
                method: 'POST',
                headers: headers,
                body: body
              }, refetchConfig));

            case 16:
              response = _context.sent;
              return _context.abrupt("return", (0, _helpers.handleData)(response));

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function fetch(_x, _x2, _x3) {
      return _fetch.apply(this, arguments);
    }

    return fetch;
  }();
}